<div class="card incidencia-seguridad-ticket-modal regresar-proceso-seguridad-modal">
  <div class="card-header card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11">
        <h4 class="card-title"><b>{{ titulo }}</b></h4>
        <p class="card-category">
          Folio <strong>#{{ data?.incidencia?.idIncidenciaIa }}</strong> - {{ descripcion }}
        </p>
      </div>
      <div class="col-sm-12 col-md-1 text-right">
        <button type="button" mat-icon-button aria-label="Cerrar" (click)="cerrar()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="wraper">
      <div class="container">
        <div class="alert alert-danger regresar-proceso-seguridad-modal__alert" *ngIf="error">
          <i class="material-icons">error_outline</i>
          <span>{{ error }}</span>
        </div>

        <div class="regresar-proceso-seguridad-modal__summary">
          <span>Incidencia</span>
          <strong>{{ data?.incidencia?.tipoIncidencia || "Sin tipo" }}</strong>
          <p>{{ data?.incidencia?.descripcionEvento || "Sin descripcion" }}</p>
        </div>

        <mat-form-field appearance="outline" class="w-100 regresar-proceso-seguridad-modal__comment">
          <mat-label>{{ etiquetaComentario }}</mat-label>
          <textarea
            matInput
            [attr.aria-label]="etiquetaComentario"
            rows="4"
            maxlength="500"
            [(ngModel)]="comentario"
            name="comentario"
            required
            [placeholder]="placeholder"
          ></textarea>
        </mat-form-field>

        <div mat-dialog-actions class="justify-content-end regresar-proceso-seguridad-modal__actions">
          <button type="button" mat-button class="btn btn-default" (click)="cerrar()">
            Cancelar
          </button>
          <button type="button" mat-button class="btn btn-danger" (click)="confirmar()" [disabled]="!comentario.trim()">
            {{ textoBoton }}
            <i class="material-icons">{{ iconoBoton }}</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
